import { Gradient } from './gradient'

export const background = () => {

	const gradient = new Gradient()

	gradient.initGradient('#gradient-canvas')

	document.querySelector('[data-theme-toggle]').addEventListener('click', () => {
		gradient.initGradient('#gradient-canvas')
	})
}

export default () => {}
